import React from "react";
import Popup from "./Popup"
import Thumb from "./images/thumbs.png";
import {Link} from 'react-router-dom';
import "./styles/NavBar.css"

const NavBar = () => {
    const [myPopUp, setPopUp] = React.useState(false);
    
    return (
        <div>
            <div className="outBar">
                <Link to="/personal-website/">
                    <img src = {Thumb} width = "60px"></img>
                </Link>

                <nav>
                    <Link to="/personal-website/">Home</Link>
                    <Link to="/projects">My Portfolio</Link>
                    <Link to="/contact">Contact</Link>
                </nav>
            </div>

            <Popup showPop={myPopUp} setTrigger={setPopUp}/>            
        </div>
    );
}

export default NavBar;